import React, { useContext } from "react";
import { Input } from "antd";
import { AppContext } from "../../context";
const { TextArea } = Input;

function SpecialRequest({ setClientRequest }) {
  const handleTextArea = (e) => {
    setClientRequest(e.target.value);
    // requestRef.current = e.target.value;
    // console.log("e.target.value :>> ", e.target.value);
  };
  const info = useContext(AppContext);

  console.log("special request render");

  return (
    <>
      <div style={{ marginTop: 10 }}>{info.t("specialRequest")}</div>
      <TextArea
        showCount
        maxLength={1000}
        onChange={handleTextArea}
        style={{ marginBottom: 10 }}
      />
    </>
  );
}

export default SpecialRequest;
